import classNames from 'classnames';
import React, { ReactNode } from 'react';
import { VerticalDivider } from '../VerticalDivider';
import { SpanTooltip } from '../SpanTooltip';
import { LoadingButton } from '../LoadingButton';
import { ButtonType } from '../../utils/types/SetupPages/ButtonValue';
import { ButtonValue } from '../../utils/types/SetupPages/ButtonType';

interface PropTypes {
  title: ReactNode;
  subTitle?: ReactNode;
  firstItems: SetupHeaderButtonType[];
  intermediateItems: SetupHeaderButtonType[];
  lastItem?: SetupHeaderButtonType;
  customLastItem?: ReactNode;
  value?: string;
  classNames?: string;
  titleClassNames?: string;
}

export interface SetupHeaderButtonType {
  title: React.ReactNode;
  action?: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  isLoading?: boolean;
  type: ButtonType;
  value?: ButtonValue;
  tooltip?: string;
}

function FirstItemHeader(props: { items?: SetupHeaderButtonType[] }) {
  return (
    <>
      {props.items?.map((item, index) => (
        <LoadingButton
          key={index}
          color='secondary'
          type={item.type === 'Save' ? 'submit' : 'button'}
          onClick={item.action || null}
          disabled={item.disabled}
          value={item.value}
          isLoading={item.isLoading}
        >
          {item.title}
        </LoadingButton>
      ))}
    </>
  );
}

function LastJobItemHeader(props: { item?: SetupHeaderButtonType }) {
  if (props.item == null) {
    return null;
  }

  return (
    <>
      <LoadingButton
        color='primary'
        type='submit'
        onClick={props.item.action || null}
        disabled={props.item.disabled}
        value={props.item.value}
        isLoading={props.item.isLoading}
      >
        {props.item.title}
      </LoadingButton>
    </>
  );
}

export function SetupPageHeader(props: PropTypes) {
  return (
    <div className={classNames('d-flex', props.classNames)}>
      <div className='me-auto'>
        <h2 className={classNames(props.titleClassNames)}>{props.title}</h2>
        {props.subTitle}
      </div>
      <div className='d-flex gap-3 align-items-start'>
        <FirstItemHeader items={props.firstItems} />
        {props.firstItems?.length != 0 && (
          <VerticalDivider classNames='pb-6h' />
        )}
        {props.intermediateItems.map(
          (item: SetupHeaderButtonType, idx: number) => {
            return (
              <div key={idx}>
                {item.tooltip ? (
                  <SpanTooltip
                    tooltipText={item.tooltip || ''}
                    text={<NavButton item={item} />}
                  />
                ) : (
                  <NavButton item={item} />
                )}
              </div>
            );
          },
        )}
        {props.customLastItem ?? <LastJobItemHeader item={props.lastItem} />}
      </div>
    </div>
  );
}

function NavButton(props: { item: SetupHeaderButtonType }) {
  return (
    <LoadingButton
      color={props.item.type === 'Cancel' ? 'danger' : 'primary'}
      type={props.item.type === 'Save' ? 'submit' : 'button'}
      // TODO: SL-2891 if the action is cancel, it should show an cancel modal
      onClick={props.item.action || null}
      disabled={props.item.disabled}
      value={props.item.value}
      isLoading={props.item.isLoading}
    >
      {props.item.title}
    </LoadingButton>
  );
}
